import { jsxs as i, jsx as a, Fragment as s } from "react/jsx-runtime";
import { clsx as r } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import e from "./roche-pipeline-lane-header.module.scss.js";
const m = ({
  lane: l,
  itemCountText: n,
  hasShortLabel: p = !1
}) => /* @__PURE__ */ i("div", { className: e["pipeline-lane-header"], children: [
  /* @__PURE__ */ a("p", { className: e["pipeline-lane-header__count"], children: n }),
  p ? /* @__PURE__ */ i(s, { children: [
    /* @__PURE__ */ a(
      "p",
      {
        className: r(e["pipeline-lane-header__label"], e["pipeline-lane-header__label--short"]),
        "aria-hidden": "true",
        children: l.shortLabel ?? l.label
      }
    ),
    /* @__PURE__ */ a("p", { className: r(e["pipeline-lane-header__label"], e["pipeline-lane-header__label--full"]), children: l.label })
  ] }) : /* @__PURE__ */ a("p", { className: e["pipeline-lane-header__label"], children: l.label })
] });
export {
  m as RocheUIPipelineLaneHeader
};
